<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="startTime" >
        <span slot="label" ><a-tooltip>{{$t('投票排行榜活动管理.活动开始时间')}}<template slot="title">{{$t('投票排行榜活动管理.活动开始时间')}}</template></a-tooltip> </span>
        <a-date-picker style="width: 100%" v-model="form.startTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="endTime" >
        <span slot="label" ><a-tooltip>{{$t('投票排行榜活动管理.活动结束时间')}}<template slot="title">{{$t('投票排行榜活动管理.活动结束时间')}}</template></a-tooltip> </span>
        <a-date-picker style="width: 100%" v-model="form.endTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="title" >
        <span slot="label" ><a-tooltip>{{$t('投票排行榜活动管理.活动标题')}}<template slot="title">{{$t('投票排行榜活动管理.活动标题')}}</template></a-tooltip> </span>
        <a-input v-model="form.title" :maxLength="255" :placeholder="$t('通用.输入.请输入')+'活动标题'" >
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['title']"
            input-type="input"
            table-name="zb_huodong"
            table-field="title"
            :field-value="form.title"/>
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="coverImg" >
        <span slot="label" ><a-tooltip>{{$t('投票排行榜活动管理.封面图')}}<template slot="title">{{$t('投票排行榜活动管理.封面图')}}</template></a-tooltip> </span>
        <a-upload
          name="coverImg"
          listType="picture-card"
          :multiple="false"
          :show-upload-list="false"
          :preview="handlePreview"
          :before-upload="beforeOssUpload"
          :customRequest="coverImgUpload">
          <img
            v-if="form.coverImg"
            :src="form.coverImg"
            alt="coverImg"
            style="height: 102px; width: 102px;"/>
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">{{ $t('通用.按钮.上传') }}</div>
          </div>
        </a-upload>
        <span >推荐尺寸 343*250</span>
      </a-form-model-item>
<!--      <a-form-model-item prop="picture" >-->
<!--        <span slot="label" ><a-tooltip>{{$t('投票排行榜活动管理.活动顶部图片')}}<template slot="title">{{$t('投票排行榜活动管理.活动顶部图片')}}</template></a-tooltip> </span>-->
<!--        <a-upload-->
<!--          name="picture"-->
<!--          listType="picture-card"-->
<!--          :multiple="false"-->
<!--          :show-upload-list="false"-->
<!--          :preview="handlePreview"-->
<!--          :before-upload="beforeOssUpload"-->
<!--          :customRequest="pictureImgUpload">-->
<!--          <img-->
<!--            v-if="form.picture"-->
<!--            :src="form.picture"-->
<!--            alt="picture"-->
<!--            style="height: 102px; width: 102px;"/>-->
<!--          <div v-else>-->
<!--            <a-icon :type="loading ? 'loading' : 'plus'"/>-->
<!--            <div class="ant-upload-text">{{ $t('通用.按钮.上传') }}</div>-->
<!--          </div>-->
<!--        </a-upload>-->
<!--      </a-form-model-item>-->
      <a-form-model-item prop="introduction" >
        <span slot="label" ><a-tooltip>{{$t('投票排行榜活动管理.简介')}}<template slot="title">{{$t('投票排行榜活动管理.简介')}}</template></a-tooltip> </span>
        <a-input v-model="form.introduction" :placeholder="$t('通用.输入.请输入')" >
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['introduction']"
            :disabled="!form.introduction"
            input-type="textarea"
            table-name="zb_huodong"
            table-field="introduction"
            :field-value="form.introduction"
          />
        </a-input>

      </a-form-model-item>
      <!--                  <a-form-model-item prop="type" >-->
      <!--                        <span slot="label" ><a-tooltip>{{$t('投票排行榜活动管理.类型')}}<template slot="title">{{$t('投票排行榜活动管理.类型')}}</template></a-tooltip> </span>-->
      <!--                  </a-form-model-item>-->
      <a-form-model-item prop="content" >
        <span slot="label" ><a-tooltip>{{$t('投票排行榜活动管理.活动规则')}}<template slot="title">{{$t('投票排行榜活动管理.活动规则')}}</template></a-tooltip> </span>
        <div class="editor-i18n-wrapper">
          <editor v-model="form.content" />
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['content']"
            :disabled="!form.content"
            input-type="editor"
            table-name="zb_huodong"
            table-field="content"
            :field-value="form.content"
          />
        </div>
      </a-form-model-item>
      <a-form-model-item prop="zhongjiang" >
        <span slot="label" ><a-tooltip>{{$t('投票排行榜活动管理.前几名商品中奖')}}<template slot="title">{{$t('投票排行榜活动管理.前几名商品中奖')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.zhongjiang" :placeholder="$t('通用.输入.请输入')" allow-clear />
      </a-form-model-item>
<!--      <a-form-model-item prop="sort" >-->
<!--        <span slot="label" ><a-tooltip>{{$t('投票排行榜活动管理.排序')}}<template slot="title">{{$t('投票排行榜活动管理.排序')}}</template></a-tooltip> </span>-->
<!--        <a-input-number v-model="form.sort" :placeholder="$t('通用.输入.请输入')" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getHuodong, addHuodong, updateHuodong } from '@/api/huodong/huodong'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject, uploadOss} from "@/api/tool/oss";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";

import Editor from '@/components/Editor'
import moment from "moment/moment";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    LocaleFieldButton,
    Editor
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        title: null,
        coverImg: null,
        picture: null,
        introduction: null,
        type: null,
        content: null,
        startTime: null,
        endTime: null,
        sort: null,
        zhongjiang: null,
        localeFieldMap:{},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        startTime: [
          { required: true, message: this.$t('投票排行榜活动管理.活动开始时间')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: this.$t('投票排行榜活动管理.活动结束时间')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        title: [
          { required: true, message: this.$t('投票排行榜活动管理.活动标题')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        title: null,
        coverImg: null,
        picture: null,
        introduction: null,
        type: null,
        content: null,
        startTime: null,
        endTime: null,
        sort: null,
        zhongjiang: null,
        localeFieldMap:{},
      }

    },
    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'));
      if (suffix === '.mp4') {
        this.handleVideoPreview(file);
      } else {
        this.handleImagePreview(file);
      }
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'banner'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'coverImg', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    // 上传覆盖默认的上传行为
    pictureImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'banner'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'picture', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    coverDetailImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'banner'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'detailImg', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    formatDateTime(date) {
      if (!date) return null
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getHuodong({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.form.type=2
      // 转换时间格式
      if (this.form.startTime) {
        this.form.startTime = this.formatDateTime(this.form.startTime)
      }
      if (this.form.endTime) {
        this.form.endTime = this.formatDateTime(this.form.endTime)
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateHuodong(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addHuodong(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.editor-i18n-wrapper {
  position: relative;
}
/* deep selector to reach into child component root */
.editor-i18n-wrapper /deep/ .ant-input-suffix-button.editor-i18n-btn {
  position: absolute !important;
  bottom: 1px;
  right: 8px !important;
  z-index: 3000;
}
</style>
